import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtherSettingsListComponent } from './other-settings-list/other-settings-list.component';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { OtherSettingsService } from './other-settings.service';
import { OtherSettingsSupportContactEditComponent } from './other-settings-support-contact-edit/other-settings-support-contact-edit.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UIRouterModule } from '@uirouter/angular';
import { FiOtherSettingsStates } from './other-settings-states';
import { OtherSettingsSmtpEditComponent } from './other-settings-smtp-edit/other-settings-smtp-edit.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { OtherSettingsHelperService } from '@fi-app/other-settings/other-settings-helper.service';
import { TransferOwnershipModule } from '@fi-app/other-settings/transfer-ownership/transfer-ownership.module';
import { FiLoginReminderModule } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCardModule,
        ComponentsModule,
        UtilitiesModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        UIRouterModule.forChild(FiOtherSettingsStates),
        MatSelectModule,
        MatButtonModule,
        MatRadioModule,
        FiPageHeaderModule,
        SelectSearchModule,
        FiErrorMessageModule,
        FiWrapperTableModule,
        TransferOwnershipModule,
        FiLoginReminderModule,
    ],
    declarations: [
        OtherSettingsListComponent,
        OtherSettingsSupportContactEditComponent,
        OtherSettingsSmtpEditComponent,
    ],
    providers: [OtherSettingsService, OtherSettingsHelperService],
})
export class OtherSettingsModule {}
